<div class="glow-line" [ngClass]="arrayClasses" [ngStyle]="{ width: size, margin: margin }"></div>
